export enum ChoiceBubbleStatus {
  DEFAULT,
  SELECTED,
  CORRECT,
  INCORRECT,
}
